import React from 'react';
import SessionManager from '../../routes/SessionManager';

const NavItem = props => {
    const pathname = window.location.pathname;
    const pageURI = pathname + window.location.search;
    var paths = pageURI.split('/');
    var currPath = props.path;
    currPath = currPath.replace('/', '');

    let liClassName = (paths.indexOf(currPath) !== -1) ? "nav-item active" : "nav-item";
    let aClassName = props.disabled ? "nav-link disabled" : "nav-link";
    var content = props.name;

    //Check at no-nav-paths which are pages which are loaded independent of navigation.js
    if (liClassName === 'nav-item')
        if (props['no-nav-paths'] && props['no-nav-paths'].indexOf(pathname.replace('/', '')) !== -1)
            liClassName += ' active';

    if (props.auth && (paths.indexOf(currPath) !== -1)) {
        //console.log(JSON.stringify(props));
        var sessionManager = new SessionManager()
        const user = sessionManager.readCookie('user');
        const isSessionValid = user ? (user.token_expiry - (new Date().getTime()) > 0) : false;
        //console.log('Token Expiry : ' + user.token_expiry + ', Now : ' + (new Date().getTime()));

        if (!isSessionValid) {
            sessionManager.removeCookie('user');
            window.location = './login';
        }
    }

    let isMobileMode = window.innerWidth < 576;
    let contentLi = '';
    let prepareLi = true;
    if (isMobileMode) {
        console.log('props.mobile_mode ' + props.mobile_mode);
        if (props.mobile_mode !== undefined) {
            prepareLi = false;
        }
    }

    if (prepareLi) {
        contentLi = <li className={liClassName}>
            <a href={props.path ? props.path : "#"} className={aClassName}>
                {content}
                {(props.path === pageURI) ? (<span key={props.x} className="sr-only">(current)</span>) : ''}
            </a>
        </li>
    }


    if (prepareLi && props.path === "/") {
        contentLi = <li className={liClassName}>
            <div className={aClassName} style={{ cursor: "pointer" }}>
                {content}
                {(props.path === pageURI) ? (<span key={props.x} className="sr-only">(current)</span>) : ''}
            </div>
        </li>
    }

    return contentLi;
}

export default NavItem;